// extracted by mini-css-extract-plugin
export var auto = "_3e-1";
export var spinner = "_3e-0";